module.exports = __webpack_public_path__ + "img/admin.d2a03f13.png";